import { graphql } from "@/graphql/gql-tada"

export const collectionFragment = graphql(`
  fragment Collection on Collection @_unmask {
    id
    slug
    name
    description
    featuredAsset {
      id
      preview
      name
    }
  }
`)

export const GET_COLLECTIONS = graphql(
  `
    query GetCollections($options: CollectionListOptions) {
      collections(options: $options) {
        items {
          ...Collection
        }
      }
    }
  `,
  [collectionFragment],
)

export const GET_COLLECTION = graphql(
  `
    query GetCollection($slug: String!) {
      collection(slug: $slug) {
        ...Collection
      }
    }
  `,
  [collectionFragment],
)
